import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/CONTACT.webp"
          alt="Contact Rafael M&C Constructions"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
              Ready to Start
              <br />
              Your Project?
            </h2>
            <p className="text-base md:text-lg text-background-50/80 max-w-md leading-relaxed mb-8">
              Let&apos;s bring your vision to life. Contact us today for a free, no-obligation estimate and consultation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Get Free Estimate
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="tel:+15713652634"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-transparent border border-background-50/30 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                (571) 365-2634
              </a>
            </div>
          </div>

          <div className="hidden lg:flex flex-col items-end">
            <div className="bg-background-50/10 backdrop-blur-md border border-background-50/20 rounded-2xl p-6 md:p-8 max-w-sm">
              <h3 className="font-heading text-xl font-semibold text-background-50 mb-4">Business Hours</h3>
              <div className="space-y-2.5">
                {[
                  { day: 'Monday - Friday', hours: '8:00 AM – 6:00 PM' },
                  { day: 'Saturday', hours: '8:00 AM – 6:00 PM' },
                  { day: 'Sunday', hours: 'Closed' },
                ].map((item) => (
                  <div key={item.day} className="flex justify-between text-sm">
                    <span className="text-background-50/70">{item.day}</span>
                    <span className="text-background-50 font-medium">{item.hours}</span>
                  </div>
                ))}
              </div>
              <div className="mt-5 pt-5 border-t border-background-50/15">
                <p className="text-xs text-background-50/50">
                  Serving Sterling, Northern Virginia, Maryland &amp; Washington D.C.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}